(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  $('.logo-list').slick({
    dots: false, // Add dots navigation if needed
    arrows: false, // Add arrows if needed
    infinite: true, // Loop through slide
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnDotsHover: false, // Prevent pausing when hovering over dots
    pauseOnFocus: false, // Prevent pausing when focused on dots
    pauseOnHover: false, // Prevent pausing on hover

    responsive: [
        {
            breakpoint: 9999,
            settings: "unslick"
        },
        {
            breakpoint: 760,
             settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                     dots: true,
                     autoplay: true,
                     autoplaySpeed: 2000,
                     pauseOnDotsHover: false,
                     infinite: false,
                     centerMode: false,  // Center the active image
                }
        },
   {
            breakpoint: 990,
             settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                      dots: true,
                       autoplay: true,
                      autoplaySpeed: 2000,
                       centerMode: true,
                       pauseOnDotsHover: false, 
                }
        }

    ]
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
  $('.text-with-icons').slick({
    dots: false, // Add dots navigation if needed
    arrows: false, // Add arrows if needed
    infinite: true, // Loop through slide
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
     pauseOnDotsHover: false, // Prevent pausing when hovering over dots
    pauseOnFocus: false, // Prevent pausing when focused on dots
    pauseOnHover: false, // Prevent pausing on hover

    responsive: [
        {
            breakpoint: 9999,
            settings: "unslick"
        },
    {
            breakpoint: 391,
             settings: {
                    slidesToShow: 1.28,
                    slidesToScroll: 1,
                     dots: true,
                      centerMode: true,
                     autoplaySpeed: 2000,
                       pauseOnDotsHover: false, 
                }
        },
        {
            breakpoint: 760,
             settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                     dots: true,
                      centerMode: true,
                     autoplaySpeed: 2000,
                       pauseOnDotsHover: false, 
                }
        },
   {
            breakpoint: 990,
             settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                      dots: true,
                       autoplaySpeed: 2000,
                        pauseOnDotsHover: false, 
                }
        }

    ]
  });


  } catch(e) { console.error(e); }
})();
})();
